<template>
    <div id="KassensystemAuswahl">
        <div id="ProjektAuswahl">
            <div>
                Kassenprojekt auswählen:
                <div id="kassenProjekte">
                    <div class="kassenProjektItem" v-for="projekt in this.kassenprojekte" :key="projekt.kassenProjektID" @click="openKassenprojekt(projekt)">
                        {{ projekt.bezeichnung }}
                    </div>
                </div>
            </div>
        </div>
        <button @click="createKassenProjekt()">Kassenprojekt anlegen</button>
    </div>
    <router-link :to="`/mehr/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>
</template>

<script>
import Swal from 'sweetalert2';
import axios from 'axios';
import { Kassenprojekt } from '@/backend_controller/kassenprojekt';

export default {
  name: "KassensystemAuswahl",
  components: {

  },
  props: {

  },
  data() {
    return {
      kassenprojekte: []
    };
  },
  methods: {
    async createKassenProjekt (){
        var html = "";
        html += `<input style="width: 100%" id="name" maxLength="20" class="swal2-input" placeholder="Bezeichnung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
        html += `<input style="width: 100%" id="passwort" maxLength="20" class="swal2-input" placeholder="Passwort" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;

        const { value: formValues } = await Swal.fire({
            title: "Kassenprojekt anlegen",
            html: html,
            focusConfirm: false,
            preConfirm: () => {
                const name = document.getElementById("name").value;
                const passwort = document.getElementById("passwort").value;
                return { name, passwort };
            }
        });

        if (formValues) {
            const name = formValues.name;
            const passwort = formValues.passwort;

            await this.erstelleKassenProjekt(name, passwort);
        }
    },
    async refreshKassenprojekte(){
        this.kassenprojekte = [];
        this.kassenprojekte = await this.holeKassenProjekte();
    },
    async erstelleKassenProjekt(bezeichnung, passwort){
        var kassenProjektID;
        var feuerwehrID =  await this.getFeuerwehr();
        if(this.kassenprojekte.length > 0){
            kassenProjektID = +this.kassenprojekte[this.kassenprojekte.length - 1].kassenProjektID + 1;
        } else{
            kassenProjektID = 1;
        }
        const projektData = {
            kassenProjektID: kassenProjektID,
            bezeichnung: bezeichnung,
            passwort: passwort,
            feuerwehrID: feuerwehrID,
            geldstand: 0
        };

        var response = await Kassenprojekt.add(projektData);
        if(response){
            this.refreshKassenprojekte();
        }
    },
    async holeKassenProjekte(){
        /*var konvKey = this.$route.params.id.replace(":", "");
        return await Kassenprojekt.get(konvKey);*/
        try{
            var konvKey = this.$route.params.id.replace(":", "");
            const response = await Kassenprojekt.get(konvKey);
            localStorage.setItem("kassenprojekt", JSON.stringify(response));
            return response;
        } catch(err){
            console.log(err);
            return JSON.parse(localStorage.getItem("kassenprojekt"));
        }
    },
    async getFeuerwehr() {
        try {
          var konvKey = this.$route.params.id.replace(":", "");
          const response = await axios.get(
            'https://feuerwehr-server.org:5000/feuerwehrBykonvKey', { params: { konvKey: konvKey } }
          );
            return response.data.feuerwehrID;
        } catch (err) {
          console.log(err);
        }
      },
      openKassenprojekt(projekt){
        Swal.fire({
            title: "Passwort",
            input: "password",
            showCancelButton: true,
            confirmButtonText: "Weiter",
            preConfirm: (eingabe) => {
            return eingabe;
            }
        }).then((result) => {
            if(result.isConfirmed){
                if(result.value == projekt.passwort){
                    this.goToKassenprojekt(projekt);
                } else{
                    Swal.fire({
                        title: "Öffnen nicht möglich",
                        text: "Das eingegebene Passwort ist nicht korrekt",
                        icon: "error"
                    });
                    console.log("Error");
                }
            }
        });
      },
      goToKassenprojekt(projekt){
        this.$emit('openKassensystemMain', projekt);
      }
  },
  async created(){
    this.kassenprojekte = await this.holeKassenProjekte();
  }
};
</script>

<style lang="scss" scoped>
#KassensystemAuswahl{
    background-color: rgb(238, 239, 243);
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;

    #ProjektAuswahl{
        margin-top: 2vh;
        height: 80vh;
        width: 100vw;
        font-size: x-large;
        display: flex;
        justify-content:center;

        #kassenProjekte{
            background-color: white;
            border: solid black 3px;
            border-radius: 5px;
            height: 75vh;
            width: 80vw;
            margin-top: 0.3rem;
        }
    }
}
</style>